import { render } from "./WoTEventsShowView.vue?vue&type=template&id=746ed3f0"
import script from "./WoTEventsShowView.vue?vue&type=script&lang=js"
export * from "./WoTEventsShowView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__